import React, { useRef, useState, useEffect } from "react";
import { Form, Modal, Overlay, Tooltip } from "react-bootstrap";
import InputDetail from "./InputDetail";
import infobtn from "../../assets/images/infobtnblue.svg";
import Json from "../../assets/images/json.svg";
import { commonservices } from "../../services/CommonServices";
import { PasswordVaultgetlist } from "../../services/ReduxTookit/Slice/PasswordVaultRedux";
import { useDispatch, useSelector } from "react-redux";
import { setWorkFlowGetListData, WorkFlowGetList } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { ENUMS } from "../../services/Enums";
import ObjectViewModel from "../Workflow/FlowNewModels/ObjectViewModel";
import { Editor } from "@monaco-editor/react";
const SingleSelect = ({ compObj, handleChange, isDisable, showtype, labelAction, nodeContext }) => {
    let dispatch = useDispatch();

    let dropDownOption = [];
    if (compObj?.paravalueselection) {
        let CheckJson = commonservices.IsValidJson(compObj?.paravalueselection);
        if (CheckJson) {
            dropDownOption = JSON.parse(compObj?.paravalueselection);
        }
    }

    const [IsSystemSelection, setIsSystemSelection] = useState(false);
    const [DDL_Option, setDDL_Option] = useState(dropDownOption);



    const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
    const targetInputDetail = useRef();
    const targetConfig = useRef(null);

    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const [ObjData, setObjData] = useState("");
    const [ObjName, setObjName] = useState("");
    const [parentOutputFiles, setParentOutputFiles] = useState([]);

    const handleShowConfigPopup = () => {
        setShowConfigPopup(!showConfigPopup);
    };

    const getOutputSampleJson = async (filepath) => {
        try {
            if (!filepath) return null;
            const response = await fetch(filepath);
            if (!response.ok) return null;
            return await response.json();
        } catch (error) {
            return null;
        }
    };

    const getLoopKeyOptionsFromParentOutputs = async () => {
        const selectedNodeId = nodeContext?.selectedNode?.id;
        const edgeList = nodeContext?.edges || [];
        const machineList = nodeContext?.allMachineList?.dataList1 || [];

        if (!selectedNodeId || edgeList.length === 0 || machineList.length === 0) {
            return [];
        }

        const NoOfParent = edgeList.filter((item) => item.target === selectedNodeId);
        if (!NoOfParent || NoOfParent.length === 0) {
            return [];
        }

        const parentFiles = [];
        for (let i = 0; i < NoOfParent.length; i++) {
            if (NoOfParent[i].source_machineid && NoOfParent[i].source_shortname) {

                const outputFileName = NoOfParent[i].source_shortname + ".json";
                const isAlreadyAdded = parentFiles.some(
                    (d) => d.outputfilename === outputFileName
                );

                if (!isAlreadyAdded) {
                    const objmachine = machineList.filter(
                        (m) => m.machineid === parseInt(NoOfParent[i].source_machineid)
                    );

                    if (objmachine && objmachine.length > 0 && objmachine[0].outputsamplefile) {

                        const lastValue = NoOfParent[i].source_image.split('/').pop().replaceAll(":", "-").replaceAll(".", "-") + "-" + NoOfParent[i].source_machineid;
                        let machinename = NoOfParent[i].source_machinename + NoOfParent[i].source_shortname.replaceAll(lastValue, "-");
                        if (machinename.endsWith("-")) {
                            machinename = machinename.slice(0, -1);
                        }

                        parentFiles.push({
                            source_machinename: NoOfParent[i].source_machinename,
                            machinename: machinename,
                            outputfilename: outputFileName,
                            outputsamplefile: objmachine[0].outputsamplefile,
                        });
                    }
                }
            }
        }
        return parentFiles;

        // if (parentFiles.length === 0) {
        //     return [];
        // }

        // const allOptions = [];
        // for (let i = 0; i < parentFiles.length; i++) {
        //     const sampleJson = await getOutputSampleJson(parentFiles[i].outputsamplefile);

        //     if (!sampleJson || typeof sampleJson !== "object") {
        //         continue;
        //     }

        //     const keyPathSet =  commonservices.extractArrayKeyPaths(sampleJson);
        //     if (keyPathSet.size === 0) {
        //         continue;
        //     }

        //     Array.from(keyPathSet).forEach((keyPath) => {
        //         const datavalue = keyPath.split(".").reduce((o, key) => o?.[key], sampleJson);
        //         allOptions.push({ "filename": parentFiles[i].machinename, "keypath": keyPath, "value": parentFiles[i].outputfilename + "->" + keyPath, "datavalue": JSON.stringify(datavalue) });
        //     });
        // }
        // return [...new Set(allOptions)];
    };

    const handleOutputFromJsonPreview = async (e) => {
        e.preventDefault();

        if (!compObj?.value) return;

        const selectedParentFile = parentOutputFiles.find(
            (item) => item.outputfilename === compObj.value
        );

        if (!selectedParentFile?.outputsamplefile) {
            return;
        }

        const sampleJson = await getOutputSampleJson(selectedParentFile.outputsamplefile);
        if (!sampleJson) {
            return;
        }

        setObjData(JSON.stringify(sampleJson, null, 2));
        setObjName(selectedParentFile.machinename || selectedParentFile.source_machinename || "Output Sample");
        setShowConfigPopup(true);
    };

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };

    const handleShowInputDetailPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowInputDetailPopu(!showInputDetailPopup);
    };


    useEffect(() => {
        if (compObj) {
            if (compObj.parakey) {
                if (compObj.parakey.toUpperCase() === "OUTPUT_FROM") {
                    getLoopKeyOptionsFromParentOutputs()
                        .then((options) => {
                            setParentOutputFiles(options);

                            setIsSystemSelection(true);
                            dropDownOption = options.reduce((acc, item) => {
                                if (!acc[item.source_machinename]) {
                                    acc[item.source_machinename] = [];
                                }
                                acc[item.source_machinename].push({ value: item.outputfilename, text: item.machinename, datavalue: "" });
                                return acc;

                                // if (!acc[item.filename]) {
                                //     acc[item.filename] = [];
                                // }
                                // acc[item.filename].push({ value: item.value, text: item.keypath, datavalue: item.datavalue });
                                // return acc;
                            }, {});
                            setDDL_Option(dropDownOption);
                        })
                        .catch(() => {
                            setParentOutputFiles([]);
                            setDDL_Option(dropDownOption);
                        });
                }

                if (compObj.parakey.toUpperCase() === "VAULT_ID") {
                    dispatch(PasswordVaultgetlist({}))
                        .then((response) => {
                            if (response?.payload?.isValidate) {
                                if (response?.payload?.data?.data) {
                                    setIsSystemSelection(true);
                                    dropDownOption = response?.payload?.data?.data.reduce((acc, item) => {
                                        if (!acc[item.type]) {
                                            acc[item.type] = [];
                                        }
                                        acc[item.type].push({ value: item.passwordvaultid, text: item.displayname, datavalue: "" });
                                        return acc;
                                    }, {});
                                    setDDL_Option(dropDownOption);
                                }
                            }
                        })
                        .finally(() => {

                        });
                }

                if (compObj.parakey.toUpperCase() === "WORKFLOW_NAME") {
                    dispatch(WorkFlowGetList({ searchText: "" }))
                        .then((response) => {
                            if (response?.payload?.isValidate) {
                                if (response?.payload?.data?.data) {
                                    setIsSystemSelection(true);
                                    dropDownOption = response?.payload?.data?.data.reduce((acc, item) => {
                                        if (!acc[item.workspacename]) {
                                            acc[item.workspacename] = [];
                                        }
                                        acc[item.workspacename].push({ value: item.workflowkey, text: item.workflowname, datavalue: "" });
                                        return acc;
                                    }, {});
                                    setDDL_Option(dropDownOption);
                                }
                            }
                        })
                        .finally(() => {

                        });
                }
            }
        }
    }, [compObj, nodeContext]);

    return (
        <>
            <div className="config-input-label-container">
                <Form.Label className="common-label text-capitalize">
                    {compObj?.parakey.replaceAll("_", " ")}
                    {showtype && <> ({compObj?.paratype})</>}
                </Form.Label>
                {compObj?.details && (
                    <span
                        className="config-info-btn cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            handleOverlay(e);
                            setShowInputDetailPopu(!showInputDetailPopup);
                            handleShowInputDetailPopup();
                        }}
                        ref={targetInputDetail}
                    >
                        <img src={infobtn} alt="infobtn" />
                    </span>
                )}
                {
                    !ENUMS.workflowparamsnotbindonthiskey.includes(compObj?.parakey.toUpperCase()) &&
                    labelAction
                }
            </div>
            {
                IsSystemSelection ?
                    <Form.Select
                        className="common-select mb-2"
                        value={compObj?.value ? compObj?.value : ""}
                        onChange={(e) => {
                            // if (compObj.parakey.toUpperCase() === "LOOP_KEY") {
                            //     if (nodeContext) {
                            //         nodeContext.selectedNode.loopKeySampleData = "";
                            //         let datavalue = Object.values(DDL_Option).flat().find(item => item.value === e.target.value)?.datavalue;
                            //         if (datavalue) {
                            //             nodeContext.selectedNode.loopKeySampleData = datavalue;
                            //         }
                            //     }
                            // }
                            if (handleChange) {
                                handleChange(e, compObj);
                            }
                        }}
                        disabled={isDisable ? isDisable : false}
                    >
                        <option value="">Select</option>
                        {Object.entries(DDL_Option).map(([type, items]) => (
                            <optgroup key={type} label={type}>
                                {items.map(item => (
                                    <option
                                        key={item.value}
                                        value={item.value}
                                    >
                                        {item.text}
                                    </option>
                                ))}
                            </optgroup>
                        ))}

                    </Form.Select>
                    :
                    <Form.Select
                        className="common-select mb-2"
                        value={compObj?.value ? compObj?.value : ""}
                        onChange={(e) => {
                            if (handleChange) {
                                handleChange(e, compObj);
                            }
                        }}
                        disabled={isDisable ? isDisable : false}
                    >
                        <option value="">Select</option>
                        {Array.isArray(DDL_Option) &&
                            DDL_Option?.map((item) => {
                                return (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                );
                            })}
                    </Form.Select>
            }

            {compObj?.parakey?.toUpperCase() === "OUTPUT_FROM" && compObj?.value && (
                <div className="output_from_sample_file" ref={targetConfig} onClick={handleOutputFromJsonPreview}>
                    Sample File
                </div>
            )}

            {showInputDetailPopup && (
                <Overlay
                    target={targetInputDetail.current}
                    show={handleShowInputDetailPopup}
                    placement="bottom"
                    flip
                >
                    <Tooltip id="overlay-example">
                        <InputDetail
                            handleshowPopup={handleShowInputDetailPopup}
                            compObj={compObj}
                        />
                    </Tooltip>
                </Overlay>
            )}

            {showConfigPopup && (
                <Modal
                    show={showConfigPopup}
                    onHide={() => setShowConfigPopup(false)}
                    centered
                    size="xl"
                    className="workflow-data-profile-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{ObjName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0 }}>
                        <Editor
                            height="45vh"
                            language={"json"}
                            value={ObjData}
                            options={{
                                readOnly: true,
                                minimap: { enabled: false },
                            }}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export default SingleSelect;
